<script>
  import { Tabs, Tab } from 'carbon-components-svelte';

  import { useNavigate, useLocation } from 'svelte-navigator';

  export let tabsWrapperProps,
    tabs,
    defaultHash,
    param = '',
    defaultParamValue = '';

  const navigate = useNavigate();
  const location = useLocation();

  const selectTab = ({ hash, key }) => {
    if (param) {
      const url = new URL(window.location.href);
      url.searchParams.set(param, key);
      navigate(url.pathname + url.search + url.hash);
    } else {
      navigate($location.pathname + hash);
    }
  };

  function handleTabChange(event) {
    const tab = tabs?.[event.detail];
    if (tab && event.detail !== selectedTabIndex) {
      selectTab(tab);
    }
  }

  $: currentHash = $location?.hash || defaultHash || '';

  $: if (!param) {
    const url = new URL(window.location);
    url.hash = currentHash;
    window.history.replaceState({}, '', url);
  }

  $: paramValue = param ? new URLSearchParams($location?.search ?? '').get(param) : null;

  $: selectedTabIndex = param
    ? Math.max(0, tabs?.findIndex(({ key }) => key === (paramValue || defaultParamValue)) ?? -1)
    : currentHash
    ? tabs?.findIndex(({ hash, activeForChildHashes }) => {
        return hash === currentHash || (activeForChildHashes && currentHash.startsWith(hash));
      })
    : 0;
</script>

<Tabs {...tabsWrapperProps} selected={selectedTabIndex} on:change={handleTabChange}>
  {#each tabs as { hash, key, ...props }}
    <Tab {...props} />
  {/each}

  <svelte:fragment slot="content">
    <div class="banner-wrapper">
      <slot name="banner" />
    </div>
    <slot selectedIndex={selectedTabIndex} />
  </svelte:fragment>
</Tabs>

<style>
  .banner-wrapper {
    position: relative;
  }
</style>
